<app-type-desc-marche [uid]="getUid()" [parentForm]="parentForm" [natureMarche]="rectificatif.natureMarche" [disabled]="disabled">
</app-type-desc-marche>